/*
 * Copyright (c) Worldline 2022.
 */

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {RedirectionService} from "../../services/redirection.service";

@Component({
  selector: 'app-legal-notices',
  templateUrl: './legal-notices.component.html'
})
export class LegalNoticesComponent implements OnInit {

  constructor(private route: ActivatedRoute, private redirectionService: RedirectionService) {
  }

  private sessionId: any;

  ngOnInit(): void {
    this.sessionId = this.route.snapshot.params['sessionId'];
  }

  back() {
    this.redirectionService.session(this.route, this.sessionId);
  };

}
